import { NavigationProp, useNavigation, useRoute } from '@react-navigation/native';
import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';
import { RootStackParamList } from 'navigation/AppNavigator';
import { useEffect, useState } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import theme from 'theme';
import { getAppVersion } from 'utils/getAppVersion';

import { Icons } from 'components/Icons';
import Separator from 'components/Separator';

type FooterItemConfig = { title: string; route: keyof RootStackParamList };

const footerConfig: FooterItemConfig[] = [
  { title: 'Não encontrou o que procurava? Fale Conosco', route: 'ContactUs' },
  { title: 'Perguntas Frequentes', route: 'FaqSection' },
  { title: 'Termos e Condições', route: 'LegalTerms' },
];

export function HelperFooter() {
  const route = useRoute();
  const [version, setVersion] = useState('');
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const contentGap = useBreakpointValueGS({ base: 16, xl: 48, lg: 48 }) || 16;
  const separatorMaxWidth = useBreakpointValueGS({ base: undefined, xl: 600, lg: 600 });
  const contentDirection = useBreakpointValueGS({ base: 'column', xl: 'row', lg: 'row' });

  useEffect(() => {
    getAppVersion().then(setVersion);
  }, []);

  const renderFooterItem = (config: FooterItemConfig, index: number) => {
    const isCurrentRoute = route.name === config.route;
    const itemColor = isCurrentRoute ? theme.colors.base.white : theme.colors.base.purple;

    return (
      <Pressable
        key={index}
        style={styles.footerItem}
        disabled={isCurrentRoute}
        onPress={() => navigation.navigate<any>(config.route)}>
        <View style={styles.footerItemContent}>
          <Text style={[styles.footerItemText, { color: itemColor }]}>{config.title}</Text>
          <Icons.ChevronRight color={theme.colors.base.white} />
        </View>
      </Pressable>
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.separatorContainer}>
        <Separator style={{ maxWidth: separatorMaxWidth }} />
      </View>

      <View
        style={[
          styles.content,
          { gap: contentGap, flexDirection: contentDirection as 'column' | 'row' },
        ]}>
        {footerConfig.map(renderFooterItem)}
      </View>

      <View style={styles.versionContainer}>
        <Text style={styles.versionText}>versão: {version}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    paddingBottom: 8,
    gap: 16,
  },
  separatorContainer: {
    marginBottom: 4,
  },
  content: {
    width: '100%',
    alignItems: 'flex-start',
  },
  footerItem: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  footerItemContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  footerItemText: {
    fontWeight: '600',
    fontSize: theme.fontSizesPx.md,
    fontFamily: 'system-ui',
    lineHeight: 22,
  },
  versionContainer: {
    marginBottom: 16,
  },
  versionText: {
    fontSize: 12,
    color: theme.colors.base.white,
    opacity: 0.3,
  },
});
